module.exports = __webpack_public_path__ + "media/images/icons/save-pdf-dc42e17c29f9f86b1a10bdf4bafb8f93.svg";